<!--
 * @Author: fengzhongmei
 * @Date: 2020-05-20 16:18:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-15 13:24:25
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="details"
         style="padding:0px">
        <div v-if="!loading">
            <template v-if="productName==='套餐包'&&renewDetails.config">
                <Row>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('计费类型')}}：</span>
                        <span class="value"
                              :title="defaultChargeTypeData[renewDetails.config.billingType]||'--'">{{defaultChargeTypeData[renewDetails.config.billingType]||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('套餐类型')}}：</span>
                        <span class="value"
                              :title="availableZonesList[renewDetails.config.bagType]||'--'">{{availableZonesList[renewDetails.config.bagType]||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('产品')}}：</span>
                        <span class="value"
                              :title="renewDetails.config.productType">{{productTypeData[renewDetails.config.productType] || renewDetails.config.productType}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('规格')}}：</span>
                        <span class="value"
                              :title="renewDetails.config.bagSpecName">{{renewDetails.config.bagSpecName}}</span>
                    </div>
                    </Col>
                    <!-- <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('购买数量')}}：</span>
                        <span class="value"
                              :title="renewDetails.config.quantity">{{renewDetails.config.quantity}}</span>
                    </div>
                    </Col> -->
                    <!-- <Col span="8">
                    <div class="show-item">
                        <span class="title">{{$t('购买时长')}}：</span>
                        <span class="value"
                              :title="renewDetails.config.times">{{renewDetails.config.times}}</span>
                    </div>
                    </Col> -->
                </Row>
            </template>
            <template v-else>
                <!-- 实例详情 -->
                <Row v-if="renewDetails.config&&renewDetails.productCode==='HPC-DRP'">
                    <Col :span="['计算节点', '登录节点', 'VNC节点','管理节点','文件系统', '备注'].includes(item.label)?12:12"
                         v-for="(item,index) in renewDetails.config"
                         :key="index">
                    <div class="show-item"
                         v-if="item.label && !item.isHidden  && (item.desc || (item.chidrenDesc && item.chidrenDesc.length))">
                        <span class="title"
                              :title="$t(item.label)">{{$t(item.label)}}：</span>
                        <span class="value">
                            <span v-if="item.chidrenDesc && item.chidrenDesc.length">
                                <span style="display: block;"
                                      v-for="(element, index) in item.chidrenDesc"
                                      :key="index">
                                    <template v-for="(elementItem, index) in element"
                                              v-if="elementItem.isShow || item.label==='管理节点'">
                                        <span :key="elementItem.label + index"
                                              style="margin-right:10px;">{{elementItem.label}} </span>
                                        <span :key="elementItem.label"
                                              class="itemValue"
                                              :title="elementItem.value || '--'"
                                              style="margin-right:20px;"> {{elementItem.value || '--'}}</span>
                                        <span :key="index"
                                              class="item-spece">|</span>
                                    </template>
                                </span>
                            </span>
                            <span v-else> {{Array.isArray(item.desc) ? item.desc.join('，') : item.desc.value || '--' }}</span>
                        </span>
                    </div>
                    </Col>
                </Row>
                <Row v-if="configDetails&&renewDetails.productCode!=='HPC-DRP'">
                    <Col span="8"
                         v-for="(item,index) in configDetails"
                         :key="index">
                    <div class="show-item">
                        <span class="title"> {{$t(item.label)}}：</span>
                        <span class="value"
                              :title="$t(item.label)+'：'+item.value">
                            {{(item.value===null||item.value==='')?'--':item.value}}
                        </span>
                    </div>
                    </Col>
                </Row>
            </template>
            <Row>
                <div class="endTime">
                    <Col span="8">
                    <span>{{$t("当前资源到期时间")}}：</span><b>{{renewDetails.endTime || '--'}}</b>
                    </Col>
                    <Col span="8"
                         v-if="renewDetails.frozenTime">
                    <span>{{$t("冻结时间")}}：</span><b>{{renewDetails.frozenTime || '--'}}</b>
                    </Col>
                    <Col span="8"
                         v-if="renewDetails.makeUpDays">
                    <span>{{$t("补扣区间")}}：</span><b>{{renewDetails.makeUpDays || '--'}}</b>
                    </Col>
                </div>
            </Row>
        </div>
        <div v-if="loading"
             class="custom-loading"
             style="height: 150px">
            <Spin fix></Spin>
        </div>
    </div>
</template>

<script>
export default {
    name: 'detailsitem',
    props: ['renewDetails', 'productType', 'productName'],
    data () {
        return {
            loading: true,
            HPCDRPinf: [],
            availableZonesList: { discount: '折扣包', resouce: '资源包' },
            defaultChargeTypeData: { PrePaid: '包年包月' },
            productTypeData: { HPC: 'HPC共享资源池' }
        }
    },
    created () {
        this.loading = true
        this.$nextTick(function () {
            setTimeout(() => {
                this.loading = false
            }, 400)
        })
    },
    computed: {
        configDetails () {
            const { productCode, config = '{}', inquiryJson } = this.renewDetails || {}
            const resConfig = JSON.parse(JSON.stringify(config))
            if (productCode === 'DRP') {
                const { unitComputingPower = 0 } = JSON.parse(inquiryJson || '{}')
                resConfig.forEach(item => {
                    if (item.attrKey === 'count' && unitComputingPower) {
                        const val = Number(item.value.split('/')[0])
                        if (isNaN(val)) return
                        item.value += `（${(val * unitComputingPower).toFixed(2)} PFLOPS）`
                    }
                })
            }
            return resConfig
        }
    }
}
</script>
<style lang="less" scoped>
.confirm-container {
    .instance-item {
        display: flex;
        padding-top: 20px;
        .show-item {
            margin-bottom: 15px;
            font-size: 12px;
            display: flex;
            .title {
                display: inline-block;
                width: 120px;
                color: #999;
                text-align: right;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                overflow: hidden;
            }
            .value {
                display: inline-block;
                width: calc(~'100% - 120px');
                position: relative;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                overflow: hidden;
            }
            .itemValue {
                display: inline-block;
                max-width: 40%;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                white-space: nowrap;
                vertical-align: bottom;
            }
            .item-spece {
                width: 1px;
                height: 100%;
                padding-right: 20px;
                display: inline-block;
                &:last-child {
                    display: none;
                }
            }
        }
    }
}
.endTime {
    font-size: 13px;
    padding: 10px 0;
    // padding: 10px 15px;
    // background: #f5f6f7;
    // margin: 0px 15px 0px 20px;
    span {
        color: #999;
        width: 120px;
        text-align: end;
        display: inline-block;
    }
    b {
        font-size: 12px;
        font-weight: 600;
        padding: 0 5px;
        // vertical-align: middle;
        color: #f57d18;
    }
}
</style>
